import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "../hrmTour.css";

export function startOvertimeListTour() {
  const steps = [{ popover: { title: "Hướng dẫn nhanh", description: "Tổng quan luồng đăng ký, duyệt, báo cáo và review tăng ca.", side: "over", align: "center" } }];
  const segments = [
    ['[data-tour="hrm-overtime-header"]', "Tiêu đề trang", "Hiển thị tổng số phiếu và nút mở tour nhanh.", "bottom"],
    ['[data-tour="hrm-overtime-filter"]', "Bộ lọc tăng ca", "Lọc phiếu tăng ca theo khoảng ngày, đơn vị, trạng thái.", "bottom"],
    ['[data-tour="hrm-overtime-pending"]', "Phiếu chờ duyệt", "Xử lý các phiếu pending/waiting_level_2.", "top"],
    ['[data-tour="hrm-overtime-running"]', "Phiếu đang thực hiện", "Theo dõi các phiếu đã duyệt và đang chạy.", "top"],
    ['[data-tour="hrm-overtime-review"]', "Phiếu chờ review", "Theo dõi các phiếu đã báo cáo, chờ đánh giá cuối.", "top"],
    ['[data-tour="hrm-overtime-table"]', "Bảng tổng hợp tăng ca", "Danh sách đầy đủ để tra cứu và mở chi tiết từng phiếu.", "top"],
  ];
  for (const [selector, title, description, side] of segments) {
    const el = document.querySelector(selector);
    if (!el) continue;
    steps.push({ element: el, popover: { title, description, side } });
  }
  if (steps.length <= 1) return window.alert("Không tìm thấy vùng để chạy hướng dẫn.");
  driver({ showProgress: true, smoothScroll: true, popoverClass: "hrm-tour-popover", nextBtnText: "Tiếp", prevBtnText: "Trước", doneBtnText: "Xong", progressText: "Bước {{current}} / {{total}}", steps }).drive();
}
